import { HealthType, TitleTagType } from '../model';

export const HealthMapping: { [key in HealthType]: { text: string; healthType: TitleTagType } } = {
  HEALTHY: {
    text: 'Healthy',
    healthType: 'POSITIVE',
  },
  WARNING: {
    text: 'Warning',
    healthType: 'WARNING',
  },
  CRITICAL: {
    text: 'Critical',
    healthType: 'NEGATIVE',
  },
  UNKNOWN: {
    text: 'Unknown',
    healthType: 'INACTIVE',
  },
};
